<script>
import options from './StafetDonationStepOne.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-donation-step-one kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourSupportTitle }}
    </h2>

    <div class="kb-stafet-step__input-wrapper">
      <FormRadioGroup
        :radioOptions="radioOptions"
        v-model="donationType"
        fieldName="donationType"
        label=""
        :errorMessageLabel="labels.yourSupportPrivateSupportRadioErrorMessage"
        v-on:change="updateDonationType($event.target.value)"
      />
    </div>

    <SupportSelector
      :stafetId="stafetId"
      :labels="labels"
      :displayInputError="displayInputError"
      :onChangeCallback="updateSupportSelector"
      :holdList="holdList"
    />

    <div class="kb-stafet-step__input-wrapper">
      <FormInputTextField
        :modelValue="donationAmount.toString()"
        v-model="donationAmount"
        :label="labels.yourSupportAmountLabel"
        :isRequired="true"
        fieldName="donationAmount"
        type="number"
        :isValidationError="showDonationAmountErrorMessage"
        :placeholder="labels.yourSupportAmountPlaceholder"
        :errorMessageLabel="labels.yourSupportAmountErrorMessage"
        :onChangeCallback="(e) => setDonationAmount(e.target.value)"
      />

      <FormInputTextarea
        fieldName="comment"
        :modelValue="comment"
        v-model="comment"
        :label="labels.yourSupportCommentLabel"
        :maxlength="250"
        :placeholder="labels.yourSupportCommentPlaceholder"
        :errorMessageLabel="labels.yourSupportCommentErrorMessage"
        v-on:input="updateComment($event.target.value)"
      />
    </div>

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationNextStep1"
    />
  </article>
</template>
